import {StateUtils} from '@spartacus/core';
import {
  CustomUserOrdersAction,
  LOAD_USER_ORDERS_STATUS_FAIL,
  LOAD_USER_ORDERS_STATUS_SUCCESS,
  USER_ORDERS_STATUS
} from '../actions/custom-user-order.action';
import {OrderStatusList, StateOrderStatusList} from '../../../../model/order-status-list.model';
import {ActionReducerMap} from '@ngrx/store';
import {InjectionToken} from '@angular/core';

export const initialState: OrderStatusList = {
  items: []
};

export function reducer(
  state = initialState,
  action: CustomUserOrdersAction
): OrderStatusList {
  switch (action.type) {
    case LOAD_USER_ORDERS_STATUS_SUCCESS: {
      return action.payload ? action.payload : initialState;
    }
    case LOAD_USER_ORDERS_STATUS_FAIL: {
      return initialState;
    }
  }

  return state;
}

export function getReducers(): ActionReducerMap<StateOrderStatusList> {
  return {
    entities: StateUtils.loaderReducer<OrderStatusList>(USER_ORDERS_STATUS, reducer),
  };
}

export const reducerOrderStatusListToken: InjectionToken<ActionReducerMap<StateOrderStatusList>> =
  new InjectionToken<ActionReducerMap<OrderStatusList>>('OrderStatusListReducer');

export const reducerOrderStatusListProvider = {
  provide: reducerOrderStatusListToken,
  useFactory: getReducers,
};

